<template>
  <li>
    <button
      @click="$emit('toggled', id, title)"
      class="flex flex-col gap-xs text-left border-none p-none cursor-pointer bg-transparent group"
      :data-ec="ec"
      :data-et="`select_${itemType}_card`"
      data-test="image-button"
      role="checkbox"
      :aria-label="title"
      :aria-checked="selected"
    >
      <div
        class="relative rounded-md"
        :class="{ 'group-hover:shadow-card2': !selected }"
      >
        <VCheckbox
          type="checkbox"
          :checked="selected"
          @input="$emit('toggled', id, title)"
          class="!absolute top-sm right-sm"
          data-test="checkbox"
          :data-ec="ec"
          :data-et="`select_${itemType}_card_checkbox`"
          tabindex="-1"
          aria-hidden="true"
        />

        <AtomImage
          tabindex="-1"
          aria-hidden="true"
          class="border border-solid rounded-md border-border w-cardThumbnailW h-cardThumbnailH"
          :class="{
            'border-3 border-signableBrandColours-signableBlue': selected,
          }"
          :src="image"
          :error="require('@/assets/error.png')"
          :alt="imageAlt"
          data-hj-suppress
        />
      </div>

      <BasePopover
        trigger="hover"
        :disabled="!titleIsTruncated"
        :delay="300"
      >
        <template v-slot:reference>
          <div
            class="text-14 font-normal text-signableBrandColours-black max-w-cardThumbnailW truncate"
            data-test="title"
            ref="titleRef"
          >
            {{ title }}
          </div>
        </template>
        <template v-slot:popper-content>
          <div class="max-w-contextMenuMaxWidth !break-words">{{ title }}</div>
        </template>
      </BasePopover>

      <BasePopover
        v-if="secondaryInfo"
        trigger="hover"
        class="w-full sm:w-auto"
        :disabled="!secondaryInfoIsTruncated"
        :delay="300"
      >
        <template v-slot:reference>
          <div
            class="text-12 font-normal text-signableBrandColours-darkGrey truncate max-w-cardThumbnailW"
            data-test="secondary-info"
            ref="secondaryInfoRef"
          >
            {{ secondaryInfo }}
          </div>
        </template>
        <template v-slot:popper-content>
          <div class="max-w-contextMenuMaxWidth !break-words">{{ secondaryInfo }}</div>
        </template>
      </BasePopover>
    </button>
  </li>
</template>

<script>
import { defineComponent, computed, ref } from 'vue';

import AtomImage from '@/components/atoms/Image.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import BasePopover from '@/components/library/popovers/BasePopover.vue';

export default defineComponent({
  components: { VCheckbox, AtomImage, BasePopover },
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    title: String,
    secondaryInfo: String,
    id: String,
    image: String,
    ec: String,
    itemType: String,
    imageAlt: String,
  },
  setup(props) {
    const titleRef = ref(null);
    const secondaryInfoRef = ref(null);

    const titleIsTruncated = computed(() => {
      if (props.title && titleRef.value) {
        return titleRef.value.offsetWidth < titleRef.value.scrollWidth;
      }
      return false;
    });
    const secondaryInfoIsTruncated = computed(() => {
      if (props.secondaryInfo && secondaryInfoRef.value) {
        return secondaryInfoRef.value.offsetWidth < secondaryInfoRef.value.scrollWidth;
      }
      return false;
    });

    return {
      titleRef,
      secondaryInfoRef,
      titleIsTruncated,
      secondaryInfoIsTruncated,
    };
  },
});
</script>
